import { useRef } from 'react';
import ArtistRow from './ArtistRow';
import { groupLineupByDay, rowSizeForArtist, splitByRole, voteKey } from '../../utils/lineupFormat';

/**
 * Votable lineup grouped by role (Headliners / Support). When singleDay is set,
 * only that day's artists render — used by the day-by-day voting flow.
 */
export default function LineupVoteList({
  lineup = [],
  selectedKeys,
  onToggle,
  filterDays = null,
  singleDay = null,
  listRef,
}) {
  const internalRef = useRef(null);
  const scrollRef = listRef || internalRef;

  const visible = lineup.filter((row) => {
    if (singleDay) return row.performance_day === singleDay;
    if (filterDays) return !row.performance_day || filterDays.includes(row.performance_day);
    return true;
  });

  if (visible.length === 0) {
    return <p className="py-6 text-center text-sm text-ink/60">No lineup announced yet.</p>;
  }

  const days = singleDay ? [{ day: singleDay, rows: visible }] : groupLineupByDay(visible);

  return (
    <div ref={scrollRef}>
      {days.map(({ day, rows }) => {
        const blocks = splitByRole(rows);

        return (
          <section key={day ?? 'no-day'}>
            {blocks.map((block) => {
              const labelClass =
                block.key === 'headliner'
                  ? 'role-block-label role-block-label--headliner'
                  : 'role-block-label role-block-label--support';
              // Null label and no set times means this block gets no header at
              // all: it is the acts below the headliners, and "Support" is
              // billing language rather than something to tell an attendee.
              const heading = block.timeRange ?? block.label;

              return (
                <div key={`${day ?? 'no-day'}:${block.key}`}>
                  {heading ? <h4 className={labelClass}>{heading}</h4> : null}
                  <div>
                    {block.rows.map((row) => {
                      const key = voteKey(row.artist_id, row.performance_day);
                      return (
                        <ArtistRow
                          key={key}
                          artist={row}
                          size={rowSizeForArtist(row)}
                          layout="vote"
                          selected={selectedKeys?.has(key) ?? false}
                          onToggle={onToggle}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </section>
        );
      })}
    </div>
  );
}
